import { store } from '../store/store'
import LogIn from '../components/LogIn'
import MainContainer from '../components/MainContainer'
import GroupsUsers from '../components/GroupsUsers'
import Statistic from '../components/Statistic'
import Reports from '../components/Reports'
import News from '../components/News'
import PackageStatistic from '../components/PackageStatistic'
import ReportActiveUsers from '../components/ReportActiveUsers'
import ProductClient from '../components/ProductClient'
import ReportFixedPackages from '../components/ReportFixedPackages'
import DealersPrices from '../components/DealersPrices'
import DealerPricesForm from '../components/dealerPrices/DealerPricesForm'

import PageNotFound from '../components/PageNotFound'

const ifAuthenticated = (to, from, next) => {
  if (store.getters['authorization/isAuthenticated']) {
    next()
    return
  }
  next('/login')
}

export const routes = [
  {
    path: '/',
    component: MainContainer,
    name: 'main-container',
    meta: { title: 'user', name: 'Личный кабинет' },
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '/administration/organisations-users',
        component: GroupsUsers,
        name: 'organisations-users',
        meta: { title: 'user', name: 'Организации и пользователи' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/administration/dealers-prices',
        component: DealersPrices,
        name: 'dealers-prices',
        meta: { title: 'user', name: 'Дилеры и прайсы' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/administration/dealers-prices/:id',
        component: DealerPricesForm,
        name: 'dealer-prices-form',
        meta: { title: 'user', name: 'Дилер' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/sales-statistic',
        component: Statistic,
        name: 'sales-statistic',
        meta: { title: 'user', name: 'Статистика продаж' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/active_users',
        component: ReportActiveUsers,
        name: 'report_active_users',
        meta: { title: 'user', name: 'Отчет по учетным записям' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/report_fixed_packages',
        component: ReportFixedPackages,
        name: 'report_fixed_packages',
        meta: { title: 'user', name: 'Тариф минимальный' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/package-statistic',
        component: PackageStatistic,
        name: 'package-statistic',
        meta: { title: 'user', name: 'Статистика по пакетам' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports/:name',
        component: Reports,
        name: 'reports',
        meta: { title: 'user', name: 'Отчеты' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/product/client',
        component: ProductClient,
        name: 'client',
        meta: { title: 'user', name: 'Скачать дистрибутив' },
        beforeEnter: ifAuthenticated
      },
      {
        path: '/administration/categories',
        component: News,
        name: 'categories',
        meta: { title: 'user', name: 'Категории и записи' },
        beforeEnter: ifAuthenticated
      }
    ]
  },
  {
    path: '/login',
    component: LogIn,
    name: 'log-in'
  },
  {
    path: '*', component: PageNotFound
  }
]
